<template>
  <Tab data-cy="archived-lists">
    <template #title>Archived Lists</template>
    <div class="dwp-h-full dwp-divide-x dwp-divide-gray-100" v-loading="loading">
      <template v-if="Object.keys(archived).length">
        <template v-for="item in archived">
          <List
            :list="item"
            :key="item.id"
            @click.native.prevent="currentList = item; open = false;"
          >
            <div class="dwp-tooltip-wrap" @click="restore(item)" data-cy="restore-list">
              <RefreshCcwIcon class="dwp-w-3 dwp-h-3 dwp-text-gray-500" />
              <p class="dwp-tooltip">Un-Archive</p>
            </div>
          </List>
        </template>
      </template>
      <div
        v-else
        class="dwp-text-xs dwp-justify-center dwp-px-8 dwp-py-2 dwp-flex dwp-text-gray-500 dwp-items-center dwp-truncate dwp-rounded-r-full dwp-mr-6 dwp-space-x-2"
      >No Lists</div>
    </div>
  </Tab>
</template>

<script>
import Tab from "./templates/TabTemplate.vue";
import List from "./List.vue";
import { RefreshCcwIcon } from "vue-feather-icons";
import { get } from "vuex-pathify";

export default {
  components: {
    Tab,
    RefreshCcwIcon,
    List,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    lists: get("lists/items"),
    archived() {
      return this.filterObject(this.lists || {}, (list) => {
        return list.status == "archived";
      });
    },
  },

  // add archived to realtime updates
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("lists/bindArchived", { clearModule: true });
    this.loading = false;
  },

  // return to normal
  async beforeDestroy() {
    await this.$store.dispatch("lists/bindLists", { clearModule: true });
  },

  methods: {
    restore(list) {
      this.$store.dispatch("lists/rePublish", list);
    },
  },
};
</script>